<template>
  <div class="container mt-4">
    <div class="row">
      <div class="col-12 mx-auto">
        <!-- Tillage Simulation -->
        <TillageSimulation />
      </div>
    </div>
  </div>
</template>

<script>
import TillageSimulation from "@/components/activity/TillageSimulation.vue";

export default {
  name: "ActivityView",
  components: {
    TillageSimulation
  },
  data() {
    return {};
  },
  computed: {},
  methods: {}
};
</script>
